import { useBrokerFirm } from 'queries/broker/useBrokerFirm';
import { useIsHppPermissionedPagesEnabled } from 'providers/PosthogProvider';
import { isPreceptFinanceFirm } from 'utils/preceptFinanceFirm';

export function useCanAccessHppPages() {
  const isFeatureEnabled = useIsHppPermissionedPagesEnabled();
  const { data: firm, isLoading: isFirmLoading } = useBrokerFirm();

  const hasHppPermission = firm?.hasHppPermissions === 'YES';
  const canAccess = isFeatureEnabled && (hasHppPermission || isPreceptFinanceFirm(firm));

  return {
    canAccess,
    isFeatureEnabled,
    isLoading: isFirmLoading,
  };
}
